const loadExperienceMenu = () => {
    let header = document.querySelector('.page-header')
    let menu = document.querySelector('.experience-nav-links')

    if (menu) {
        window.addEventListener('scroll', () => {
            if (header.getBoundingClientRect().bottom < 60) {
                menu.classList.add('fixed')
            } else {
                menu.classList.remove('fixed')
            }
        })
    }
}

export default loadExperienceMenu



// WEBPACK FOOTER //
// ./js/experienceMenu.js